// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { i18n, changeLocalization } from './i18n';
import {BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueEllipseProgress from 'vue-ellipse-progress';
import VeeValidate from 'vee-validate';
import Treeselect from '@riophae/vue-treeselect';
import VueCookies from 'vue-cookies';
import App from './App';
import router from './router';
import store from './store';
import CustomFilter from './plugins/CustomFilter';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import AuthenticationService from './services/AuthenticationService';
import EventBus from '@/services/EventBus.js';

window._ = require('lodash');

Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueEllipseProgress);
Vue.use(VeeValidate, { errorBagName: 'validationErrors', fieldsBagName: 'validationFields' });
Vue.use(CustomFilter);

Vue.component('treeselect', Treeselect);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID);

let highestZIndex = 100, activeDraggable = null;
Vue.directive('draggable', {
  bind: function (el) {
    var startX, startY, initialMouseX, initialMouseY;

    // Give all components a different zIndex
    el.style.zIndex = highestZIndex++;
    el.style.position = 'absolute';

    function mousemove(e) {
      if ((e.clientX >= 10) && (e.clientX <= window.innerWidth - 10)) {
        var dx = e.clientX - initialMouseX;
        el.style.left = startX + dx + 'px';
      }
      if ((e.clientY >= 50) && (e.clientY <= window.innerHeight - 50)) {
        var dy = e.clientY - initialMouseY;
        el.style.top = startY + dy + 'px';

      }
      return false;
    }

    function mouseup() {
      document.body.classList.remove("disable-text-selection");
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    }

    el.children[0].addEventListener('mousedown', function (e) {
      document.body.classList.add("disable-text-selection");

      startX = el.offsetLeft;
      startY = el.offsetTop;
      initialMouseX = e.clientX;
      initialMouseY = e.clientY;
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
      return false;
    });

    // Draggable elements will stay in visible part while resizing
    window.addEventListener("resize", function () {
      if (el.style.left != "") {
        if (window.innerWidth < parseInt(el.style.left) + 40) {
          el.style.left = (window.innerWidth - 60) + "px";
        }
        if ((window.innerHeight < parseInt(el.style.top) + 30) && window.innerHeight > 80) {
          el.style.top = (window.innerHeight - 50) + "px";
        }
      }
    });

    // Set component on top on focus change (click in element)
    el.addEventListener('mousedown', function (e) {
      // Only fire, if another component is clicked
      if (activeDraggable === el)
        return;
      activeDraggable = el;

      // We keep order by just increasing the zIndex
      el.style.zIndex = highestZIndex++;
    });
  },
});

// Set element 
EventBus.$on('set-topmost-element', (el) => {
  if ((el instanceof Element) && (el?.style))
    el.style.zIndex = highestZIndex++;
  else
    console.warn('Argument is no DOM element. Type: ', typeof el)
});

function startApp() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    i18n
  });
}

changeLocalization('en-GB')
  .then(_ => { startApp(); })
  .catch(_ => { startApp(); });

  // See also https://router.vuejs.org/guide/advanced/lazy-loading.html
  const applyDefaultStyle = () => {
    // Custom CI f BMW Motorrad, bei gleicher Plattform
    // Sonderlocke für BMW und BMW Motorrad 
    if (APP_TARGET === "bmw") {
      if (!window.location.hostname.includes("bmwmotorrad")) {
        return import('./../scss/style-APP_TARGET.scss')
      } else {
        return import('./../scss/style-bmwmotorrad.scss')
      }
    }
    // Sonderlocke Ende

    // Default verhalten
    return import('./../scss/style-APP_TARGET.scss');
  }

let styleHook = router.beforeEach((to, from, next) => {
  // Unregister hook
  styleHook();

  // Use customized theme if generic platform and authenticated client user
  if (APP_TARGET === '' && AuthenticationService.isAuthenticated &&
      !AuthenticationService.isMSMUser && AuthenticationService.localUserProfile.ClientId)
  {
    let stylesheetLink = document.createElement('link');
    stylesheetLink.rel = 'stylesheet';
    stylesheetLink.href = `${process.env.BASE_URL}api/users/css?clientId=${AuthenticationService.localUserProfile.ClientId}`;
    stylesheetLink.onload = next;
    stylesheetLink.onerror = () => {
      applyDefaultStyle().then(() => { next(); });
    };
    document.head.appendChild(stylesheetLink);
  }
  else {
    applyDefaultStyle().then(() => { next(); });
  }
});